import Routes from "routes";
import ThemeCustomization from "themes";
import Locales from "components/Locales";
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from "components/ScrollTop";
import Snackbar from "components/@extended/Snackbar";
import Notistack from "components/third-party/Notistack";
import { FirebaseProvider as AuthProvider } from "contexts/FirebaseContext";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { subscribeToOrders } from "store/reducers/order";
import { subscribeToSales } from "store/reducers/sale";
import { subscribeToLists } from "store/reducers/list";
import { subscribeToDataRevenue } from "store/reducers/data";

/**
 * Main component of the application.
 * Manages the subscription to various data sources.
 */
const App = () => {
  const dispatch = useDispatch();
  const unsubscribeDataRevenue = useRef(null);
  const unsubscribeOrders = useRef(null);
  const unsubscribeSales = useRef(null);
  const unsubscribeLists = useRef(null);

  useEffect(() => {
    // Subscribe to Firestore when the component mounts
    unsubscribeDataRevenue.current = subscribeToDataRevenue();
    unsubscribeOrders.current = subscribeToOrders();
    unsubscribeSales.current = subscribeToSales();
    unsubscribeLists.current = subscribeToLists();

    // Unsubscribe from Firestore when the component unmounts
    return () => {
      if (unsubscribeDataRevenue.current) {
        unsubscribeDataRevenue.current();
      }

      if (unsubscribeOrders.current) {
        unsubscribeOrders.current();
      }

      if (unsubscribeSales.current) {
        unsubscribeSales.current();
      }

      if (unsubscribeLists.current) {
        unsubscribeLists.current();
      }
    };
  }, [dispatch]);

  return (
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <>
              <Notistack>
                <Routes />
                <Snackbar />
              </Notistack>
            </>
          </AuthProvider>
        </ScrollTop>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>
  );
};

export default App;
